<template>
  <div class="container">
    <el-container>
      <el-header class="header">
        <headers />
      </el-header>
      <el-container>
        <slider />
        <el-main>
          <div class="main_box">
            <div class="main_main">
              <!--Header-->
              <div class="page_header">
                {{
                  step == 2
                    ? "View New Request"
                    : "Set Priority and Assign Task"
                }}
              </div>
              <!--Header-->
              <div class="page_main">
                <el-form
                  ref="form"
                  :model="info"
                  label-position="top"
                  class="request-form"
                >
                  <el-form-item label="CAPA ID" class="full-width-item">
                    <div class="gray-input">
                      {{ info.request_id || "/" }}
                    </div>
                  </el-form-item>
                  <div class="form-grid">
                    <!-- 左侧 -->
                    <div class="form-col">
                      <el-form-item label="Status">
                        <div class="gray-input">
                          {{ info.status_name || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Priority">
                        <div class="gray-input">
                          {{ info.priority || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Investigator">
                        <div class="gray-input">
                          {{ info.investigator || "/" }}
                        </div>
                      </el-form-item>
                    </div>
                    <!-- 右侧 -->
                    <div class="form-col">
                      <el-form-item label="Request Date">
                        <div class="gray-input">
                          {{ info.time1 || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Acceptance Date">
                        <div class="gray-input">
                          {{ info.time2 || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Investigation Start Date">
                        <div class="gray-input">
                          {{ info.time3 || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Investigation Completion Date">
                        <div class="gray-input">
                          {{ info.time4 || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Implementation Start Date">
                        <div class="gray-input">
                          {{ info.time5 || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Implementation Completion Date">
                        <div class="gray-input">
                          {{ info.time6 || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Close Date">
                        <div class="gray-input">
                          {{ info.pass_time || "/" }}
                        </div>
                      </el-form-item>
                    </div>
                  </div>
                  <div class="text-tip">CAPA Description</div>
                  <el-form-item
                    label="Description of the Issue, Concern, Idea, or Opportunity"
                    class="full-width-item"
                  >
                    <div class="gray-input">
                      {{ info.description || "/" }}
                    </div>
                  </el-form-item>
                  <div class="text-tip">Background Information</div>
                  <div class="form-grid">
                    <!-- 左侧 -->
                    <div class="form-col">
                      <el-form-item label="Requester">
                        <div class="gray-input">
                          {{ info.username || "/" }}
                        </div>
                      </el-form-item>
                      <!-- <el-form-item label="Company">
                        <div class="gray-input">
                          {{ info.company_name || "/" }}
                        </div>
                      </el-form-item> -->
                    </div>
                    <!-- 右侧 -->
                    <div class="form-col">
                      <el-form-item label="Source Type">
                        <div class="gray-input">
                          {{ info.source_type || "/" }}
                        </div>
                      </el-form-item>
                      <el-form-item label="Department">
                        <div class="gray-input">
                          {{ info.departments_name || "/" }}
                        </div>
                      </el-form-item>
                    </div>
                  </div>
                  <el-form-item
                    label="Source Information"
                    class="full-width-item"
                  >
                    <div class="gray-input">
                      {{ info.source_info || "/" }}
                    </div>
                  </el-form-item>
                  <div class="file-panel">
                    <div class="panel-header">
                      <div class="table-title">CAPA Background Files</div>
                    </div>
                    <el-table
                      :data="backdocTableData"
                      border
                      stripe
                      header-cell-class-name="table-header-cell"
                      class="file-table"
                      empty-text="No Data"
                    >
                      <el-table-column
                        label="Description"
                        prop="description"
                        min-width="300"
                      />
                      <el-table-column
                        label="File Name"
                        prop="name"
                        min-width="300"
                      >
                        <template #default="scope">
                          <a :href="scope.row.url" target="_blank">{{
                            scope.row.name
                          }}</a>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="file-panel">
                    <div class="panel-header">
                      <div class="table-title">
                        Articles Affected by the Issue, Concern, Idea, or
                        Opportunity
                      </div>
                    </div>
                    <el-table
                      :data="affectArticleTableData"
                      border
                      stripe
                      header-cell-class-name="table-header-cell"
                      class="file-table"
                      empty-text="No Data"
                    >
                      <el-table-column
                        prop=""
                        label="Article Type"
                        min-width="180"
                        sortable
                      >
                        <template #default="scope">
                          <div v-if="scope.row.article_type == 1">Document</div>
                          <div v-if="scope.row.article_type == 2">
                            Equipment
                          </div>
                          <div v-if="scope.row.article_type == 3">Product</div>
                          <div v-if="scope.row.article_type == 4">Tool</div>
                          <div v-if="scope.row.article_type == 5">Other</div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop="article_id"
                        label="Article ID"
                        min-width="110"
                        sortable
                      />
                      <el-table-column
                        prop="article_name"
                        label="Article Name"
                        min-width="110"
                        sortable
                      />
                      <el-table-column
                        prop="article_revision"
                        label="Article Revision"
                        min-width="140"
                        sortable
                      ></el-table-column>
                      <el-table-column
                        prop=""
                        label="Product Serial Number"
                        min-width="180"
                        sortable
                      >
                        <template #default="scope">
                          {{ scope.row.serial_number || "N/A" }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop=""
                        label="Product Lot Number"
                        min-width="160"
                        sortable
                      >
                        <template #default="scope">
                          {{ scope.row.lot_number || "N/A" }}
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop=""
                        label="Purchased Product?"
                        min-width="180"
                        sortable
                      >
                        <template #default="scope">
                          <div v-if="scope.row.is_buy == 1">Yes</div>
                          <div v-if="scope.row.is_buy == 2">No</div>
                          <div v-else></div>
                        </template>
                      </el-table-column>
                      <el-table-column
                        prop=""
                        label="Product Supplier"
                        min-width="120"
                        sortable
                      >
                        <template #default="scope">
                          {{ scope.row.supplier_name || "" }}
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <div class="file-panel">
                    <div class="panel-header">
                      <div class="table-title">Correction</div>
                    </div>
                    <el-table
                      :data="correctionTableData"
                      border
                      stripe
                      header-cell-class-name="table-header-cell"
                      class="file-table"
                      empty-text="No Data"
                    >
                      <el-table-column
                        label="Description"
                        prop="description"
                        min-width="300"
                      />
                      <el-table-column
                        label="File Name"
                        prop=""
                        min-width="300"
                      >
                        <template #default="scope">
                          <a :href="scope.row.url" target="_blank">{{
                            scope.row.name
                          }}</a>
                        </template>
                      </el-table-column>
                    </el-table>
                  </div>
                  <!-- Bottom Buttons -->
                  <div v-if="step == 2" class="footer-actions">
                    <div class="btn-group">
                      <el-button
                        type="primary"
                        size="small"
                        @click="handleRequest"
                      >
                        Edit Request Information
                      </el-button>
                      <el-button
                        type="primary"
                        size="small"
                        @click="handleLater"
                      >
                        Complete Later
                      </el-button>
                    </div>
                    <div class="btn-group bottom-group">
                      <el-button
                        type="primary"
                        size="small"
                        @click="handleApprove"
                      >
                        Approve
                      </el-button>
                      <el-button
                        type="primary"
                        size="small"
                        @click="handleReturn"
                      >
                        Return for More Information
                      </el-button>
                      <el-button
                        type="primary"
                        size="small"
                        @click="handleReject"
                      >
                        Reject - No Action Required
                      </el-button>
                    </div>
                  </div>
                  <div v-if="step == 3" class="footer-btn">
                    <el-button
                      type="primary"
                      size="small"
                      @click="handleRequest"
                    >
                      Edit Request Information
                    </el-button>
                    <el-button type="primary" size="small" @click="handleStar">
                      Start Investigation
                    </el-button>
                    <el-button
                      type="primary"
                      size="small"
                      @click="handlePostpone"
                    >
                      Postpone Request
                    </el-button>
                    <el-button type="primary" size="small" @click="handleLater">
                      Complete Later
                    </el-button>
                  </div>
                </el-form>
              </div>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
    <!--Signature Dialog-->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="30%">
      <div class="save_box">
        <div class="form_box">
          <div style="padding-bottom: 20px; font-weight: bold; font-size: 16px">
            Please Complete the Following Information
          </div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="0px"
          >
            <div class="input_el">
              <div
                class="tit"
                :class="{ required: dialogTitle == 'Reject Signature Request' }"
              >
                Comments
              </div>
              <el-form-item label="" prop="remark">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="ruleForm.remark"
                  placeholder="Please Enter"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
            <div class="input_el">
              <div class="tit required">Password</div>
              <el-form-item label="" prop="signature">
                <el-input
                  v-model="ruleForm.signature"
                  placeholder="Please Enter"
                  clearable
                  show-password
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="btn_box">
          <van-button
            class="btn_el"
            type="default"
            round
            @click="dialogVisible = false"
            >Cancel</van-button
          >
          <van-button
            class="btn_el"
            round
            color="linear-gradient(to right, #7BC1FF, #4886FF)"
            @click="submitForm('ruleForm')"
            >Sign</van-button
          >
        </div>
      </div>
    </el-dialog>
    <!--Signature Dialog-->
    <!--Return for More Information Dialog-->
    <el-dialog
      title="Return for More Information"
      :visible.sync="dialogVisible1"
      width="30%"
    >
      <div class="save_box">
        <div class="form_box">
          <div style="padding-bottom: 20px; font-weight: bold; font-size: 16px">
            Please Complete the Following Information
          </div>
          <el-form
            :model="ruleForm1"
            :rules="rules1"
            ref="ruleForm1"
            label-width="0px"
          >
            <div class="input_el">
              <div class="tit required">Task Instructions</div>
              <el-form-item label="" prop="shuoming">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="ruleForm1.shuoming"
                  placeholder="Please Enter"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
            <div class="input_el">
              <div class="tit required">Task Owner</div>
              <el-form-item label="" prop="account">
                <el-select
                  filterable
                  v-model="ruleForm1.account"
                  placeholder="Please Select"
                  class="full-width"
                  clearable
                >
                  <el-option
                    v-for="value in usersList"
                    :key="value.id"
                    :label="value.username"
                    :value="value.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="input_el">
              <div class="tit required">Task Due Date</div>
              <el-form-item label="" prop="task_end_time">
                <el-date-picker
                  v-model="ruleForm1.task_end_time"
                  type="date"
                  placeholder="Please Select"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </div>
            <div class="input_el">
              <div class="tit">Comments</div>
              <el-form-item label="" prop="remark">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="ruleForm1.remark"
                  placeholder="Please Enter"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
            <div class="input_el">
              <div class="tit required">Password</div>
              <el-form-item label="" prop="signature">
                <el-input
                  v-model="ruleForm1.signature"
                  placeholder="Please Enter"
                  clearable
                  show-password
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="btn_box">
          <van-button
            class="btn_el"
            type="default"
            round
            @click="dialogVisible1 = false"
            >Cancel</van-button
          >
          <van-button
            class="btn_el"
            round
            color="linear-gradient(to right, #7BC1FF, #4886FF)"
            @click="submitForm1('ruleForm1')"
            >Sign</van-button
          >
        </div>
      </div>
    </el-dialog>
    <!--Return for More Information Dialog-->
    <!--Start Investigation弹框-->
    <el-dialog
      title="Start Investigation"
      :visible.sync="dialogVisible2"
      width="30%"
    >
      <div class="save_box">
        <div class="form_box">
          <div style="padding-bottom: 20px; font-weight: bold; font-size: 16px">
            Please Complete the Following Information
          </div>
          <el-form
            :model="ruleForm2"
            :rules="rules2"
            ref="ruleForm2"
            label-width="0px"
          >
            <div class="input_el">
              <div class="tit required">Priority</div>
              <el-form-item label="" prop="priority">
                <el-select
                  filterable
                  v-model="ruleForm2.priority"
                  placeholder="Please Select"
                  class="full-width"
                  clearable
                >
                  <el-option label="High" value="1"></el-option>
                  <el-option label="Medium" value="2"></el-option>
                  <el-option label="Low" value="3"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="input_el">
              <div class="tit required">Investigator</div>
              <el-form-item label="" prop="account">
                <el-select
                  filterable
                  v-model="ruleForm2.account"
                  placeholder="Please Select"
                  class="full-width"
                  clearable
                >
                  <el-option
                    v-for="value in usersList"
                    :key="value.id"
                    :label="value.username"
                    :value="value.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="input_el">
              <div class="tit required">Response Due Date</div>
              <el-form-item label="" prop="response_end_time">
                <el-date-picker
                  v-model="ruleForm2.response_end_time"
                  type="date"
                  placeholder="Please Select"
                  style="width: 100%"
                >
                </el-date-picker>
              </el-form-item>
            </div>
            <div class="input_el">
              <div class="tit">Comments</div>
              <el-form-item label="" prop="remark">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="ruleForm2.remark"
                  placeholder="Please Enter"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
            <div class="input_el">
              <div class="tit required">Password</div>
              <el-form-item label="" prop="signature">
                <el-input
                  v-model="ruleForm2.signature"
                  placeholder="Please Enter"
                  clearable
                  show-password
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="btn_box">
          <van-button
            class="btn_el"
            type="default"
            round
            @click="dialogVisible2 = false"
            >Cancel</van-button
          >
          <van-button
            class="btn_el"
            round
            color="linear-gradient(to right, #7BC1FF, #4886FF)"
            @click="submitForm2('ruleForm2')"
            >Sign</van-button
          >
        </div>
      </div>
    </el-dialog>
    <!--Start Investigation弹框-->
    <!--Postpone CAPA Dialog-->
    <el-dialog
      title="Postpone CAPA Request"
      :visible.sync="dialogVisible3"
      width="30%"
    >
      <div class="save_box">
        <div class="form_box">
          <div style="padding-bottom: 20px; font-weight: bold; font-size: 16px">
            Please Complete the Following Information
          </div>
          <el-form
            :model="ruleForm3"
            :rules="rules3"
            ref="ruleForm3"
            label-width="0px"
          >
            <div class="input_el">
              <div class="tit required">Priority</div>
              <el-form-item label="" prop="priority">
                <el-select
                  filterable
                  v-model="ruleForm3.priority"
                  placeholder="Please Select"
                  class="full-width"
                  clearable
                >
                  <el-option label="High" value="1"></el-option>
                  <el-option label="Medium" value="2"></el-option>
                  <el-option label="Low" value="3"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="input_el">
              <div class="tit">Comments</div>
              <el-form-item label="" prop="remark">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="ruleForm3.remark"
                  placeholder="Please Enter"
                  clearable
                ></el-input>
              </el-form-item>
            </div>
            <div class="input_el">
              <div class="tit required">Password</div>
              <el-form-item label="" prop="signature">
                <el-input
                  v-model="ruleForm3.signature"
                  placeholder="Please Enter"
                  clearable
                  show-password
                ></el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="btn_box">
          <van-button
            class="btn_el"
            type="default"
            round
            @click="dialogVisible3 = false"
            >Cancel</van-button
          >
          <van-button
            class="btn_el"
            round
            color="linear-gradient(to right, #7BC1FF, #4886FF)"
            @click="submitForm3('ruleForm3')"
            >Sign</van-button
          >
        </div>
      </div>
    </el-dialog>
    <!--Postpone CAPA Dialog-->
  </div>
</template>

<script>
import { resourcesApplyDetail } from "@/api/docManage/changeRequest/index";
import { ApplyHandle } from "@/api/capaManage/capaRequest/index";
import { usersList } from "@/api/system/user";
import headers from "@/component/header.vue";
import slider from "@/component/slider.vue";
import md5 from "js-md5";
import moment from "moment";
export default {
  name: "CapaDetail",
  components: {
    headers,
    slider,
  },
  data() {
    return {
      showSolution: true,
      rootCauseExpanded: false,
      correctiveExpanded: false,
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogTitle: "Sign New Request",
      info: {},
      backdocTableData: [],
      affectArticleTableData: [],
      correctionTableData: [],
      ruleForm: {
        remark: "",
        signature: "",
      },
      rules: {
        remark: [
          {
            validator: (rule, value, callback) => {
              if (this.dialogTitle == "Reject Signature Request" && !value) {
                callback(new Error("Comments cannot be empty when rejecting"));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
        signature: [
          {
            required: true,
            message: "Please enter",
            trigger: "blur",
          },
        ],
      },
      ruleForm1: {
        shuoming: "",
        account: "",
        task_end_time: "",
        remark: "",
        signature: "",
      },
      rules1: {
    shuoming: [{
        required: true,
        message: "Please enter",
        trigger: "blur"
    }],
    account: [{
        required: true,
        message: "Please select",
        trigger: "change"
    }],
    task_end_time: [{
        required: true,
        message: "Please select",
        trigger: "change"
    }],
    signature: [{
        required: true,
        message: "Please enter",
        trigger: "blur"
    }],
},
      ruleForm2: {
        priority: "",
        account: "",
        response_end_time: "",
        remark: "",
        signature: "",
      },
      rules2: {
    priority: [{
        required: true,
        message: "Please select",
        trigger: "change"
    }],
    account: [{
        required: true,
        message: "Please select",
        trigger: "change"
    }],
    response_end_time: [{
        required: true,
        message: "Please select",
        trigger: "change"
    }],
    signature: [{
        required: true,
        message: "Please enter",
        trigger: "blur"
    }],
},
      ruleForm3: {
        priority: "",
        remark: "",
        signature: "",
      },
      rules3: {
    priority: [{
        required: true,
        message: "Please select",
        trigger: "change"
    }],
    signature: [{
        required: true,
        message: "Please enter",
        trigger: "blur"
    }],
},
      step: null,
      usersList: [],
    };
  },
  computed: {
    allExpanded() {
      return this.rootCauseExpanded && this.correctiveExpanded;
    },
  },
  mounted() {
    let that = this;
    that.step = that.$route.query.step;
    //请求用户列表
    usersList({ page: 1, page_size: 9999, status: 1 }).then((res) => {
      that.usersList = res.data.data;
    });
    //请求页面详情
    resourcesApplyDetail({ id: that.$route.query.oid }).then((res) => {
      if (res.code == 200) {
        console.log(res.data);
        if (res.data.step < 3) {
          that.info.request_id = "New Request" + "（" + res.data.request_id + "）";
        } else {
          that.info.request_id = res.data.request_id;
        }
        that.info.status_name = res.data.status_name;
        that.info.priority = res.data.priority;
        that.info.investigator = res.data.investigator;
        that.info.description = res.data.description;
        that.info.username = res.data.username;
        // that.info.company_name = res.data.company_name;
        that.info.source_type = res.data.source_type;
        that.info.departments_name = res.data.departments_name;
        that.info.source_info = res.data.source_info;
        that.info.time1 = res.data.time1;
        that.info.time2 = res.data.time2;
        that.info.time3 = res.data.time3;
        that.info.time4 = res.data.time4;
        that.info.time5 = res.data.time5;
        that.info.time6 = res.data.time6;
        that.info.pass_time = res.data.pass_time;
        that.info.step_name = res.data.step_name;
        //回显CAPA背景文件
        that.backdocTableData = res.data.capabackground_list;
        //回显更正文件
        that.correctionTableData = res.data.capacorrections_list;
        //回显受影响的文章
        that.affectArticleTableData = res.data.capaarticle_list;
      }
    });
  },
  methods: {
    //编辑请求信息
    handleRequest() {
      this.$router.push({
        path: "/CapaControl/editCapaRequest",
        query: { oid: this.$route.query.oid },
      });
    },
    //启动调查-3
    handleStar() {
      let that = this;
      that.dialogVisible2 = true;
    },
    //暂缓请求-3
    handlePostpone() {
      let that = this;
      that.dialogVisible3 = true;
    },
    //稍后完成
    handleLater() {
      let that = this;
      that.$router.back();
    },
    //批准操作-2
    handleApprove() {
      let that = this;
      that.dialogTitle = "Sign New Request";
      that.dialogVisible = true;
      that.ruleForm.remark = "";
      that.ruleForm.signature = "";
      that.$nextTick(() => {
        that.$refs.ruleForm && that.$refs.ruleForm.clearValidate();
      });
    },
    //拒绝 - 无需操作-2
    handleReject() {
      let that = this;
      that.dialogTitle = "Reject Signature Request";
      that.dialogVisible = true;
      that.ruleForm.remark = "";
      that.ruleForm.signature = "";
      that.$nextTick(() => {
        that.$refs.ruleForm && that.$refs.ruleForm.clearValidate();
      });
    },
    //返回以获取更多信息
    handleReturn() {
      let that = this;
      that.dialogVisible1 = true;
    },
    //第二步通过 、拒绝
    submitForm(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return;
        that.$toast.loading({ duration: 0, forbidClick: true });
        if (that.dialogTitle == "Reject Signature Request") {
          ApplyHandle({
            id: that.$route.query.oid,
            status: 3,
            remark: that.ruleForm.remark,
            signature: md5(that.ruleForm.signature + "AiisoQms2026"),
          }).then((res2) => {
            if (res2.code == 200) {
              that.$toast.clear();
              that.$message.success("Operation successful");
              setTimeout(() => {
                that.$router.push({ path: "/task-list" });
              }, 800);
            }
          });
        } else {
          ApplyHandle({
            id: that.$route.query.oid,
            status: 2,
            remark: that.ruleForm.remark,
            signature: md5(that.ruleForm.signature + "AiisoQms2026"),
          }).then((res2) => {
            if (res2.code == 200) {
              that.$toast.clear();
              that.$message.success("Operation successful");
              setTimeout(() => {
                that.$router.push({ path: "/task-list" });
              }, 800);
            }
          });
        }
      });
    },
    //返回获取更多信息确定
    submitForm1(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return;
        that.$toast.loading({ duration: 0, forbidClick: true });
        ApplyHandle({
          id: that.$route.query.oid,
          status: 3,
          task: that.ruleForm1.shuoming,
          apply_uid: that.ruleForm1.account,
          end_time: moment(that.ruleForm1.task_end_time).valueOf() / 1000,
          remark: that.ruleForm1.remark,
          signature: md5(that.ruleForm1.signature + "AiisoQms2026"),
        }).then((res) => {
          if (res.code == 200) {
            that.$toast.clear();
            that.$message.success("Operation successful");
            setTimeout(() => {
              that.$router.push({ path: "/task-list" });
            }, 800);
          }
        });
      });
    },
    //启动调查
    submitForm2(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return;
        that.$toast.loading({ duration: 0, forbidClick: true });
        ApplyHandle({
          id: that.$route.query.oid,
          status: 2,
          priority: that.ruleForm2.priority,
          investigator: that.ruleForm2.account,
          end_time: moment(that.ruleForm2.response_end_time).valueOf() / 1000,
          remark: that.ruleForm2.remark,
          signature: md5(that.ruleForm2.signature + "AiisoQms2026"),
        }).then((res) => {
          if (res.code == 200) {
            that.$toast.clear();
            that.$message.success("Operation successful");
            setTimeout(() => {
              that.$router.push({ path: "/task-list" });
            }, 800);
          }
        });
      });
    },
    //暂缓请求
    submitForm3(formName) {
      let that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return;
        that.$toast.loading({ duration: 0, forbidClick: true });
        ApplyHandle({
          id: that.$route.query.oid,
          status: 3,
          priority: that.ruleForm3.priority,
          remark: that.ruleForm3.remark,
          signature: md5(that.ruleForm3.signature + "AiisoQms2026"),
        }).then((res) => {
          if (res.code == 200) {
            that.$toast.clear();
            that.$message.success("Operation successful");
            setTimeout(() => {
              that.$router.push({ path: "/task-list" });
            }, 800);
          }
        });
      });
    },
    toggleAll() {
      let that = this;
      const next = !that.allExpanded;
      that.rootCauseExpanded = next;
      that.correctiveExpanded = next;
    },
    viewTask(row) {
      console.log("View Task:", row);
    },
  },
};
</script>


<style lang="less" scoped>
.save_box {
  .btn_box {
    text-align: right;

    .btn_el {
      margin-left: 10px;
      padding: 12px 24px;

      .van-button__text {
        font-size: 16px;
      }
    }
  }

  .form_box {
    .input_el {
      .tit {
        padding-bottom: 5px;
        font-size: 14px;
        color: #333333;
      }

      .required::before {
        content: "*";
        color: red;
        margin-right: 2px;
      }

      .full-width {
        width: 100%;
      }
    }
  }
}

//主要内容
.main_main {
  .page_main {
    padding: 18px 20px;

    .btn_el {
      margin: 10px 0 20px 0;

      .tips {
        padding: 6px 8px;
        background-color: #ffb1001a;
        border-radius: 6px;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }

  //页头
  .page_header {
    padding: 0 20px;
    height: 60px;
    line-height: 60px;
    background-color: #d8e4f0;
    font-size: 24px;
    font-weight: bold;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
  }
}
</style>

<style scoped>
.main_box {
  height: calc(100vh - 60px);
  overflow-y: auto;
}

.main_box .main_main {
  position: relative;
  min-height: calc(100% - 0px);
  max-height: auto;
  background-color: #fafafa;
}

.el-header,
.el-main {
  padding: 0;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 28px;
  align-items: start;
}

.form-col {
  display: flex;
  flex-direction: column;
}

.full-width-item {
  margin-top: 8px;
}

/* label 样式 */
::v-deep .el-form-item__label {
  padding-bottom: 8px;
  font-size: 14px;
  line-height: 20px;
  color: #2f343b;
  font-weight: 700;
}

/* 输入框统一风格 */
.gray-input {
  background: #e9ecef;
  border: 1px solid #cfd5db;
  color: #2f343b;
  border-radius: 8px;
  padding-left: 15px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
}

.text-tip {
  background-color: #fafafa;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 20px;
}

.file-panel {
  background: #fff;
  border: 1px solid #dcdfe6;
  margin-top: 40px;
}

.custom-panel {
  background: #fff;
  border: 1px solid #dcdfe6;
  margin-top: 10px;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
}

.table-title {
  font-size: 18px;
  font-weight: 700;
  color: #2f343b;
}

.search-input {
  width: 220px;
}

.file-table {
  width: 100%;
  margin-top: 8px;
}

.solution-plan {
  width: 100%;
  color: #303133;
  font-size: 13px;
  margin-top: 20px;
  margin-bottom: 20px;
}

.plan-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.plan-title {
  font-size: 20px;
  font-weight: 700;
  color: #1f2d3d;
  margin-right: 8px;
}

.toggle-btn {
  padding: 0;
  font-size: 13px;
}

.plan-card {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  overflow: hidden;
}

.plan-section {
  padding: 28px 20px 18px;
}

.section-title {
  margin: 0 0 26px;
  font-size: 24px;
  font-weight: 700;
  color: #303133;
}

.sub-title {
  font-size: 20px;
  font-weight: 700;
  color: #303133;
  margin-bottom: 20px;
}

.form-block {
  margin-bottom: 10px;
}

.field-label {
  display: block;
  margin-bottom: 5px;
  font-size: 14px;
  font-weight: 700;
  color: #303133;
}

.section-toggle {
  margin-top: 12px;
}

.section-toggle .el-button {
  padding: 0;
  font-size: 14px;
  font-weight: 600;
}

.divider {
  height: 1px;
  background: #ebeef5;
}

.custom-table {
  margin-bottom: 14px;
  width: 100%;
}

.el-icon-arrow-down,
.el-icon-arrow-up {
  margin-left: 2px;
}

.footer-actions {
  display: flex;
  margin-top: 50px;
  flex-direction: column;
  align-self: center;
}

.footer-btn {
  display: flex;
  margin-top: 50px;
  justify-content: center;
  align-self: center;
}

.btn-group {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bottom-group {
  margin-top: 16px;
}

.action-task-panel {
  margin-top: 20px;
}
</style>